import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { SnowplowContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { getTitleSlug } from '@/helpers/title-helper';
import { ThumborOptions } from '@/filters/thumbor';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ObjectType } from '@/@types/graphql-types';

interface SeasonsListProps {
	title: TitleDetail & { __typename: 'Show' };
	additionalContexts: SnowplowContext[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SeasonListV1',
  props: {
    title: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail & { __typename: 'Show' }, additionalContexts: SnowplowContext[] };



const seasons = computed(() => props.title.seasons ?? []);

const getImageUrl = (title: TitleDetail) => {
	return Vue.filter('Thumbor')({
		url: title.content.posterUrl,
		imageType: 'poster',
	} as ThumborOptions);
};

function trackSeasonTitleClicked(title: (TitleDetail & { __typename: 'Show' })['seasons'][0], index: number) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{ action: 'title_clicked', label: `${title.content.seasonNumber}`, property: 'season', value: index },
		[
			new SnowplowTitleContextGraphql(title?.show?.objectId, ObjectType.Show, title.content.seasonNumber),
			...props.additionalContexts,
		]
	);

	// TITLE_DETAIL_REDESIGN_NEW_BUYBOX
	// trackTitleDetailRedesignNewBuyBoxExp({ action: 'click', label: 'season_clicked' });
	// TITLE_DETAIL_REDESIGN_NEW_BUYBOX
}

return { __sfc: true,props, seasons, getImageUrl, trackSeasonTitleClicked, HiddenHorizontalScrollbar, getTitleSlug, TitleDetailLink, PictureComp }
}

})